const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

function getCurrentLanguage() {
  return localStorage.getItem('selected_language') || localStorage.getItem('tenant_default_language') || 'en'
}

function getWalletAddress() {
  let address = localStorage.getItem('wallet_address') || localStorage.getItem('address') || sessionStorage.getItem('address')
  if (address) return address
  try {
    const walletInfo = JSON.parse(localStorage.getItem('wallet_info') || '{}')
    return walletInfo.address || ''
  } catch {
    return ''
  }
}

function mapLegacyPath(url) {
  const [pathPart, queryPart] = url.split('?')
  const suffix = queryPart ? `?${queryPart}` : ''
  const mapResult = _mapPath(pathPart)
  return mapResult + suffix
}

function _mapPath(url) {
  const directMap = {
    '/wallet/details': '/c/wallet/details',
    '/wallet/user-info': '/c/wallet/user-info',
    '/wallet/disconnect': '/c/auth/logout',
    '/messages/unread-count': '/c/messages/unread-count',
    '/withdrawals/fund-password-status': '/c/withdrawals/fund-password-status',
    '/withdrawals/set-fund-password': '/c/withdrawals/set-fund-password',
    '/withdrawals/modify-fund-password': '/c/withdrawals/modify-fund-password',
    '/recharge/create-order': '/c/recharge/create-order',
    '/recharge/records': '/c/recharge/records',
    '/recharge/update-status': '/c/recharge/update-status',
    '/recharge/trigger-monitor': '/c/recharge/trigger-monitor',
    '/recharge/assets': '/c/recharge/assets',
    '/recharge/submit-manual': '/c/recharge/submit-manual',
    '/recharge/upload-proof': '/c/recharge/upload-proof',
    '/assets/wallets': '/c/assets/wallets',
    '/swap/pairs': '/c/swap/pairs',
    '/swap/quote': '/c/swap/quote',
    '/swap/execute': '/c/swap/execute',
    '/swap/records': '/c/swap/records',
    '/computing-power/settings': '/c/computing/settings',
    '/computing-power/rate-tiers': '/c/computing/rate-tiers',
    '/computing-power/dynamic-rate': '/c/computing/dynamic-rate',
    '/unstake-applications': '/c/computing/unstake-records',
    '/earnings/statistics': '/c/earnings/statistics',
    '/earnings': '/c/earnings',
    '/users/airdrop-stats': '/c/assets/airdrop-stats'
  }

  if (directMap[url]) return directMap[url]
  if (url.startsWith('/customer-service')) return url.replace('/customer-service', '/c/customer-service')
  if (url.startsWith('/users/airdrops')) return url.replace('/users/airdrops', '/c/assets/airdrops')
  if (url === '/messages') return '/c/messages'
  if (url.startsWith('/messages/')) return url.replace('/messages/', '/c/messages/')
  if (url.startsWith('/computing-power/') && url.endsWith('/earnings')) {
    return url.replace('/computing-power/', '/c/computing/applications/')
  }
  if (url.startsWith('/computing-power/') && url.endsWith('/cancel')) {
    return url.replace('/computing-power/', '/c/computing/applications/')
  }
  if (url.startsWith('/computing-power/') && url.endsWith('/unstake')) {
    return url.replace('/computing-power/', '/c/computing/')
  }
  if (url.startsWith('/computing-power/')) return url.replace('/computing-power/', '/c/computing/applications/')
  if (url === '/computing-power') return '/c/computing/applications'
  if (url.startsWith('/recharge/detail/')) return url.replace('/recharge/detail/', '/c/recharge/detail/')
  if (url.startsWith('/withdrawals')) return url.replace('/withdrawals', '/c/withdrawals')
  if (url.startsWith('/kyc')) return url.replace('/kyc', '/c/kyc')
  if (url.startsWith('/lucky-wheel/')) return url.replace('/lucky-wheel/', '/c/lucky/')
  return url
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    const text = await response.text()
    throw new Error(text || '服务器响应格式错误')
  }
  return response.json()
}

export async function request(url, options = {}) {
  const mappedUrl = url.startsWith('/system/') ? url : mapLegacyPath(url)
  const headers = { ...(options.headers || {}) }
  const token = localStorage.getItem('wallet_token')
  const walletAddress = getWalletAddress()
  const platformToken = localStorage.getItem('platform_access_token')

  headers['X-Tenant-Domain'] = window.location.hostname
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json'
  }
  if (token) headers.Authorization = `Bearer ${token}`
  if (platformToken) headers['X-Platform-Access'] = platformToken
  if (walletAddress) {
    headers['X-Wallet-Address'] = walletAddress
    headers['X-Wallet'] = walletAddress
    headers['Wallet-Address'] = walletAddress
    headers['X-User-Address'] = walletAddress
  }

  let finalUrl = mappedUrl.startsWith('http') ? mappedUrl : `${API_BASE_URL}/api${mappedUrl}`
  const params = new URLSearchParams()
  if (options.params) {
    Object.entries(options.params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value)
    })
  }
  if (!params.has('lang')) params.append('lang', getCurrentLanguage())
  finalUrl += `${finalUrl.includes('?') ? '&' : '?'}${params.toString()}`

  const response = await fetch(finalUrl, {
    method: options.method || 'GET',
    mode: 'cors',
    credentials: 'omit',
    headers,
    body: options.body
  })

  const data = await parseResponse(response)
  if (!response.ok) {
    if (response.status === 403 && data.code === 'PLATFORM_ACCESS_REQUIRED') {
      localStorage.removeItem('platform_access_token')
      const accessError = new Error(data.message || '请先输入授权码')
      accessError.code = 'PLATFORM_ACCESS_REQUIRED'
      accessError.status = 403
      throw accessError
    }
    if (response.status === 401) {
      const authError = new Error(data.message || '认证失效，请重新连接钱包')
      authError.code = 'AUTH_EXPIRED'
      authError.status = 401
      throw authError
    }
    if (response.status === 400 || response.status === 422 || response.status === 404) {
      return {
        success: false,
        message: data.message || '请求失败',
        data: data.data || null,
        errors: data.errors || null
      }
    }
    throw new Error(data.message || '请求失败')
  }

  return data
}

async function getSigningProvider(addressType = 0) {
  if (addressType === 1) {
    throw new Error('TRON 钱包验签将在第二阶段接入')
  }
  if (window.ethereum) return window.ethereum
  if (window.okxwallet) return window.okxwallet
  if (window.BinanceChain) return window.BinanceChain
  throw new Error('未检测到可用的 EVM 钱包')
}

async function signWalletLoginMessage(provider, address, message) {
  const hexMessage = '0x' + Array.from(new TextEncoder().encode(message))
    .map(b => b.toString(16).padStart(2, '0')).join('')
  try {
    return await provider.request({
      method: 'personal_sign',
      params: [hexMessage, address]
    })
  } catch (error) {
    if (error?.code === 4001) throw error
    throw error
  }
}

// 钱包 API
export const walletApi = {
  async connect(address, addressType = 0, referralCode = null) {
    const nonceResponse = await request('/c/auth/nonce', {
      method: 'POST',
      body: JSON.stringify({
        address,
        address_type: addressType,
        referral_code: referralCode,
        network: addressType === 1 ? 'tron' : 'evm',
        domain: window.location.hostname
      })
    })
    if (!nonceResponse.success) return nonceResponse

    const provider = await getSigningProvider(addressType)
    const signature = await signWalletLoginMessage(provider, address, nonceResponse.data.message)
    const response = await request('/c/auth/verify', {
      method: 'POST',
      body: JSON.stringify({
        address,
        address_type: addressType,
        nonce: nonceResponse.data.nonce,
        signature,
        referral_code: referralCode
      })
    })

    if (response.success && response.data.token) {
      localStorage.setItem('wallet_token', response.data.token)
      localStorage.setItem('user_info', JSON.stringify(response.data.user))
      localStorage.setItem('wallet_info', JSON.stringify(response.data.wallet))
      localStorage.setItem('wallet_address', response.data.wallet.address)
      localStorage.setItem('address', response.data.wallet.address)
      localStorage.setItem('addressType', String(addressType))
    }

    return response
  },

  async getUserInfo() {
    return await request('/wallet/user-info')
  },

  async getDetails() {
    return await request('/wallet/details')
  },

  async disconnect() {
    const response = await request('/wallet/disconnect', {
      method: 'POST'
    })
    
    // 清除本地存储
    localStorage.removeItem('wallet_token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('wallet_info')
    
    return response
  }
}

// 用户状态管理
export const userStore = {
  // 检查是否已登录
  isLoggedIn() {
    return !!localStorage.getItem('wallet_token')
  },

  // 获取用户信息
  getUserInfo() {
    const userInfo = localStorage.getItem('user_info')
    return userInfo ? JSON.parse(userInfo) : null
  },

  // 获取钱包信息
  getWalletInfo() {
    const walletInfo = localStorage.getItem('wallet_info')
    return walletInfo ? JSON.parse(walletInfo) : null
  },

  // 清除用户数据
  clearUserData() {
    localStorage.removeItem('wallet_token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('wallet_info')
  }
}

// 机器人 API
export const robotApi = {
  // 获取机器人列表
  async getList(status = null) {
    try {
      const result = await request('/c/ai/products')
      if (!result.success) return result
      let list = Array.isArray(result.data) ? result.data : []
      if (status) list = list.filter((item) => item.status === status)
      return { success: true, data: list }
    } catch (error) {
      console.error('🤖 机器人列表获取失败:', error)
      throw error
    }
  },

  // 获取机器人详情
  async getDetail(id) {
    return await request(`/c/ai/products/${id}`)
  },

  // 获取AI产品利率等级
  async getRateTiers() {
    return await request('/c/ai/rate-tiers')
  }
}

// 订单 API
export const orderApi = {
  // 获取用户订单列表
  async getList(params = {}) {
    const result = await request('/c/ai/orders', { params })
    if (!result.success) return result
    return {
      success: true,
      data: {
        data: result.data?.data || result.data?.list || [],
        current_page: result.data?.current_page || Number(params.page || 1),
        last_page: result.data?.last_page || 1
      }
    }
  },

  // 获取订单详情
  async getDetail(id) {
    return await request(`/c/ai/orders/${id}`)
  }
}

// 收益 API
export const earningApi = {
  async getList(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `/earnings?${queryString}` : '/earnings'
    return await request(url)
  },

  async getStatistics() {
    return await request('/earnings/statistics')
  },

  async getDetail(id) {
    return await request(`/earnings/${id}`)
  }
}

export const wealthApi = {
  async listProducts(params = {}) {
    return await request('/c/wealth/products', { params })
  },
  async getProduct(code) {
    return await request(`/c/wealth/products/${code}`)
  },
  async getSummary() {
    return await request('/c/wealth/summary')
  },
  async subscribe(code, amount, cardIds = []) {
    return await request('/c/wealth/subscribe', {
      method: 'POST',
      body: JSON.stringify({ code, amount, cardIds })
    })
  },
  async listOrders(params = {}) {
    return await request('/c/wealth/orders', { params })
  },
  async getOrder(id) {
    return await request(`/c/wealth/orders/${id}`)
  },
  async redeem(id) {
    return await request(`/c/wealth/orders/${id}/redeem`, { method: 'POST' })
  }
}

export const farmApi = {
  async getStatus() {
    return await request('/c/farm/status')
  },
  async checkIn() {
    return await request('/c/farm/check-in', { method: 'POST' })
  },
  async claimSeed(id) {
    return await request(`/c/farm/seeds/${id}/claim`, { method: 'POST' })
  },
  async waterSeed(id) {
    return await request(`/c/farm/seeds/${id}/water`, { method: 'POST' })
  },
  async friendWaterSeed(id) {
    return await request(`/c/farm/seeds/${id}/friend-water`, { method: 'POST' })
  },
  async exchangeSeed(id) {
    return await request(`/c/farm/seeds/${id}/exchange`, { method: 'POST' })
  },
  async getExperienceCards() {
    return await request('/c/farm/experience-cards')
  },
  async listFriends() {
    return await request('/c/farm/friends')
  },
  async addFriend(uid) {
    return await request('/c/farm/friends', { method: 'POST', body: JSON.stringify({ uid }) })
  },
  async removeFriend(uid) {
    return await request(`/c/farm/friends/${uid}`, { method: 'DELETE' })
  },
  async getFriendFarm(uid) {
    return await request(`/c/farm/friends/${uid}/farm`)
  }
}

// 算力申请 API
export const computingPowerApi = {
  async getSettings() {
    return await request('/computing-power/settings')
  },

  async getTypes() {
    return await request('/computing-power/types')
  },

  async getList(params = {}) {
    return await request('/computing-power', { params })
  },

  async getDetail(id) {
    return await request(`/computing-power/${id}`)
  },

  async getEarningsRecords(id) {
    return await request(`/computing-power/${id}/earnings`)
  },

  async getDynamicRate(applicationType, stakeAmount) {
    return await request('/computing-power/dynamic-rate', {
      method: 'POST',
      body: JSON.stringify({
        application_type: applicationType,
        stake_amount: stakeAmount
      })
    })
  },

  async submitApplication(data) {
    return await request('/computing-power', {
      method: 'POST',
      body: JSON.stringify(data)
    })
  },

  async cancelApplication(id) {
    return await request(`/computing-power/${id}/cancel`, {
      method: 'POST'
    })
  },

  async unstake(id) {
    return await request(`/computing-power/${id}/unstake`, {
      method: 'POST'
    })
  },

  async getComputingRateTiers() {
    return await request('/computing-power/rate-tiers')
  }
}

// 解押申请 API
export const unstakeApi = {
  async getList(params = {}) {
    return await request('/unstake-applications', { params })
  },

  async create(data) {
    return await request('/unstake-applications', {
      method: 'POST',
      body: JSON.stringify(data)
    })
  },

  async getDetail(id) {
    return await request(`/unstake-applications/${id}`)
  },

  async getByComputingApplication(computingApplicationId) {
    return await request('/unstake-applications', {
      params: { computing_application_id: computingApplicationId }
    })
  }
}

// 质押账变 API
export const stakeLogApi = {
  async getList(params = {}) {
    return await request('/c/computing/stake-logs', { params })
  },

  async getStatistics() {
    return await request('/c/computing/stake-logs')
  },

  async getRecent(limit = 10) {
    return await request('/c/computing/stake-logs', { params: { limit } })
  },

  async getDetail(id) {
    return await request('/c/computing/stake-logs', { params: { id } })
  }
}

// 通用API对象，包含所有请求方法
export const api = {
  // 通用请求方法
  async get(url, params = {}) {
    const queryString = new URLSearchParams(params).toString()
    const fullUrl = queryString ? `${url}?${queryString}` : url
    return await request(fullUrl)
  },

  async post(url, data = {}) {
    return await request(url, {
      method: 'POST',
      body: JSON.stringify(data)
    })
  },

  async put(url, data = {}) {
    return await request(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    })
  },

  async delete(url) {
    return await request(url, {
      method: 'DELETE'
    })
  }
}

// 系统配置 API
export const systemApi = {
  async getAuthAddresses() {
    return await request('/system/config')
  }
}

// 钱包授权 API
export const walletAuthApi = {
  async checkRegistration(address) {
    return { success: true, data: { address, registered: true } }
  }
}

// 空投奖励 API
export const airdropApi = {
  async getTotal(walletAddress) {
    const response = await request('/c/assets/summary')
    if (!response.success) return response
    return {
      success: true,
      data: {
        total_all: response.data.airdrop_total || '0.00',
        wallet_address: walletAddress
      }
    }
  },

  async getStats() {
    return await request('/c/assets/summary')
  },

  async getList(params = {}) {
    return await request('/c/assets/summary', { params })
  }
}

// 用户设置 API
export const userSettingsApi = {
  async checkFundPasswordStatus() {
    return await request('/withdrawals/fund-password-status')
  }
}

// 账变记录 API
export const balanceLogApi = {
  // 获取用户账变记录列表
  async getList(params = {}) {
    return await request('/c/assets/balance-logs', { params })
  },

  // 获取账变记录详情
  async getDetail(id) {
    const res = await request('/c/assets/balance-logs', { params: { id } })
    const logs = res?.data?.logs || []
    const item = logs.find((row) => row.id === Number(id)) || null
    return { success: true, data: item }
  },

  // 获取账变统计
  async getStatistics() {
    return await request('/c/assets/balance-logs')
  }
}

// 借贷 API
export const lendingApi = {
  // 获取借贷订单列表
  async getOrders(params = {}) {
    const result = await request('/c/loans/orders', { params })
    if (!result.success) return result
    return {
      success: true,
      data: Array.isArray(result.data) ? result.data : []
    }
  },

  // 获取借贷产品列表
  async getProducts(params = {}) {
    const result = await request('/c/loans/products', { params })
    if (!result.success) return result
    return {
      success: true,
      data: Array.isArray(result.data) ? result.data : []
    }
  },

  // 创建借贷订单
  async createOrder(productId, amount, days, dailyRate, applicantName, applicantPhone, idCardFrontFile, idCardBackFile) {
    const formData = new FormData()
    formData.append('lending_product_id', productId)
    formData.append('amount', amount)
    formData.append('days', days)
    formData.append('daily_rate', dailyRate)
    formData.append('applicant_name', applicantName)
    formData.append('applicant_phone', applicantPhone)
    if (idCardFrontFile) formData.append('id_card_front', idCardFrontFile)
    if (idCardBackFile) formData.append('id_card_back', idCardBackFile)

    return await request('/c/loans/orders', {
      method: 'POST',
      body: formData
    })
  }
}
